import { memo } from "react";

import { Pagination, Table, Tooltip } from "antd";
import {
  CustomRow,
  itemRender,

  pageSizeOptions
} from "utils/table";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import AllEmployeeAddPopup from "../../../../components/modelpopup/AllEmployeeAddPopup";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
// Shared with the Employees page so both lists show identical applied-filter
// chips ("Label: Value" with per-chip remove) - the directory's older local
// copy showed raw values only.
import EmployeeListFilter from "views/pages/Employees/components/EmployeeListFilter";

import FilterDrawer from "components/Drawer/filterDrawer";
import Image from "components/Image";
import { SkeltonLoader } from "components/skeltonLoader";
import { formatDateHandler2, isEventUpcoming, isoToFlag } from "utils/common";
import { useEmployee } from "../context/directoryContext";
import { useMediaQuery } from "react-responsive";

import { Button } from "components/Button";

const AllEmployee = () => {
  const {
    loading,
    employeeData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleExport,
    handleEmployeeDetailPage,
    handleDateChange,
    handleClearAll,
    isFilterDirty,
    exportLoading,
    appliedFilterCount

  } = useEmployee();




  const columns = [

    // {
    //   title: "Employee id",
    //   dataIndex: "id",
    //   sorter: true,
    //   // render: (text, record) => (
    //   //   <span className="table-avatar">
    //   //     <Link to="/profile" className="avatar">
    //   //       <img alt="" src={record.image} />
    //   //     </Link>
    //   //     <Link to="/profile">
    //   //       {text} <span>{record.role}</span>
    //   //     </Link>
    //   //   </span>
    //   // ),
    //   // sorter: (a, b) => a.name.length - b.name.length,
    // },
    // {
    //   title: "Employee number",
    //   dataIndex: "emp_no",
    //   sorter: true,
    //   // sorter: (a, b) => a.employee_id.length - b.employee_id.length,
    // },
  
    {
      title: "Name",
      dataIndex: "first_name",
      sorter: true,
      render: (text, record, index) => (
        <h2 className="table-avatar d-flex position-relative">
          <button 
            type="button"
            onClick={()=>handleEmployeeDetailPage(record.id, index)} 
            className="avatar"
            style={{ border: "none", background: "none", padding: 0, cursor: "pointer" }}
          >
            <Image src={record.profile_image}  type="user" style={{ objectFit: "cover" }} />
          </button>
          <div style={{ position: "relative", flex: 1 }}>
            <button 
              type="button"
              onClick={()=>handleEmployeeDetailPage(record.id, index)} 
              className="profile-split d-flex flex-column"
              style={{ border: "none", background: "none", padding: 0, cursor: "pointer", textAlign: "left" }}
            >
              <span style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                <span>{record.first_name} {record.middle_name} {record.last_name}</span>
                {(record?.is_celeb_birthday || isEventUpcoming(record?.employment?.employment_date)) && (
                  <span style={{ display: "flex", gap: "6px", alignItems: "center", flexShrink: 0 }}>
                    {record?.is_celeb_birthday && (
                      <span 
                        style={{
                          backgroundColor: "#10b981",
                          color: "white",
                          padding: "2px",
                          borderRadius: "50%",
                          fontSize: "10px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "18px",
                          height: "18px",
                          lineHeight: "1"
                        }}
                        title="Birthday"
                      >
                        <i className="fa fa-birthday-cake"></i>
                      </span>
                    )}
                    {isEventUpcoming(record?.employment?.employment_date) && (
                      <span 
                        style={{
                          backgroundColor: "#f59e0b",
                          color: "white",
                          padding: "2px",
                          borderRadius: "50%",
                          fontSize: "10px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "18px",
                          height: "18px",
                          lineHeight: "1"
                        }}
                        title="Work Anniversary"
                      >
                        <i className="fa fa-calendar-check"></i>
                      </span>
                    )}
                  </span>
                )}
              </span>
             {/* <span>{record?.employment?.position?.name}</span> */}
          </button>
          {record.emp_no && <span className="small text-muted">  { record.emp_no} </span>}
          </div>
        </h2>
      ),

    },
  
  
    {
      title: "Phone",
      dataIndex: "company_phone_number",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {(text || record?.contact?.mobile_no) && (
            <div>
              {text && (
                <a href={`tel:${text}`}>C: {text}</a>
              )}
              {record?.contact?.mobile_no && (
                <>
                  {text && <br/>}
                  <a href={`tel:${record?.contact?.mobile_no}`}>P: {record?.contact?.mobile_no}</a>
                </>
              )}
            </div>
          )}
        </span>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Email",
      dataIndex: "usercontact_company_user__private_email",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
         {record?.contact?.private_email}
        </span>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Designation",
      dataIndex: "user_employment_company_user__position__name",
      sorter: true,
      render: (data, record) => (
        <span className="table-avatar">
          {record?.employment?.position?.name || "—"}
        </span>
      ),
    },
    // {
    //   title: "Department ",
    //   dataIndex: "department",
    //   sorter: true,
    //   render: (data, record) => (
    //     <div>
    //       {record?.employment?.department && (
    //         <div className="dropdown">
    //           <span className="badge badge-soft-warning">{record?.employment?.department?.name}</span>  
    //           {/* <span class="badge text-bg-secondary">
    //             {record?.employment?.department?.name}
    //           </span> */}
  
        
    //         </div>
    //       )}
    //     </div>
    //   ),
    //   // sorter: (a, b) => a.joindate.length - b.joindate.length,
    // },
    {
      title: "Report To",
      dataIndex: "user_employment_company_user__report_to",
      sorter: true,
      render: (text, record, index) => (
        <>
      <h2 className="table-avatar d-flex align-items-center">
        <button
          type="button"
          onClick={() => handleEmployeeDetailPage(record?.employment?.report_to?.id, index)}
          className="avatar"
          style={{ width: '40px', height: '40px', border: "none", background: "none", padding: 0, cursor: "pointer" }}
        >
          <Image
            src={record?.employment?.report_to?.profile_image}
            type="user"
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              objectFit: 'cover',
            }}
          />
        </button>
        <div className="ms-2">
          <button
            type="button"
            onClick={() => handleEmployeeDetailPage(record?.employment?.report_to?.id, index)}
            className="profile-split d-flex flex-column"
            style={{ 
              border: "none", 
              background: "none", 
              padding: 0, 
              cursor: "pointer", 
              textAlign: "left",
              color: "rgb(211, 0, 26)"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#a0001a";
              e.currentTarget.style.textDecoration = "underline";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "rgb(211, 0, 26)";
              e.currentTarget.style.textDecoration = "none";
            }}
          >
            <span>
              {record?.employment?.report_to?.first_name} {record?.employment?.report_to?.last_name}
            </span>
            <span className="small text-muted">
              {record?.employment?.report_to?.position_name}
            </span>
          </button>
          {record?.employment?.report_to?.emp_no && (
            <span className="small text-muted">{record?.employment?.report_to?.emp_no}</span>
          )}
        </div>
      </h2>


        
         </>
      ),

    },
    {
      title: "Employment Date",
      dataIndex: "user_employment_company_user__employment_date",
      sorter: true,
      render: (text, record) => (
        <>
          {formatDateHandler2(record?.employment?.employment_date)}
          {record?.employment?.termination_date && (
            <Tooltip
              title={`Terminated date: ${formatDateHandler2(record.employment.termination_date)}`}
            >
              <span className="d-block text-danger" style={{ fontSize: 12 }}>
                {formatDateHandler2(record.employment.termination_date)}
              </span>
            </Tooltip>
          )}
        </>
      ),

      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Nationality",
      dataIndex: "nationality",
      sorter: true,
      render: (text, record) => (
        <>
          {record?.nationality?.iso && (
            <span aria-hidden="true" style={{ marginRight: 6 }}>
              {isoToFlag(record.nationality.iso)}
            </span>
          )}
          {record?.nationality?.name}
        </>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: true,
      render: (text, record) => (
        <div 
          style={{
            backgroundColor: text ? "#d1fae5" : "#fee2e2",
            color: text ? "#065f46" : "#991b1b",
            fontSize: "10px",
            padding: "4px 10px",
            fontWeight: "600",
            borderRadius: "8px",
            display: "inline-block"
          }}
        >
          {text ? "Active" : "Inactive"}
        </div>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
   
    
  ];

  // Global cache for loaded images - persists across hot reloads
  if (typeof window !== 'undefined' && !window.__loadedEmployeeImages) {
    window.__loadedEmployeeImages = new Set();
  }

  // Memoized Employee Card Component to prevent re-renders
  const EmployeeCard = memo(({ employee, index, handleEmployeeDetailPage, isEventUpcoming }) => {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const imageUrl = employee?.profile_image;
    
    return (
      <div
        className="col-lg-6 col-md-6 col-sm-12 col-xl-4 mb-3"
        key={`employee-${employee.id}`}
        data-employee-index={index}
      >
        <div 
          className="card shadow-sm"
          style={{
            borderRadius: "8px",
            border: "none",
            background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
            margin: 0,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            position: "relative",
            overflow: "hidden",
            cursor: "pointer",
            transition: "all 0.2s ease",
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
          }}
          onClick={() => handleEmployeeDetailPage(employee.id, index)}
        >
          <div className="card-body" style={{ 
            padding: isMobile ? "12px" : "16px",
            flex: 1,
            display: "flex",
            flexDirection: "column"
          }}>
          {/* Header with Avatar and Name */}
          <div className="d-flex align-items-start" style={{ marginBottom: "12px" }}>
            <div className="position-relative" style={{ flexShrink: 0, zIndex: 1 }}>
              <div 
                style={{
                  width: "72px",
                  height: "72px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.15), 0 0 0 4px rgba(255,255,255,0.8)",
                  background: "#f0f0f0",
                  transition: "transform 0.3s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  border: employee?.gender?.toLowerCase() === "female" 
                    ? "2px solid #f093fb" 
                    : employee?.gender?.toLowerCase() === "male"
                    ? "2px solid #4facfe"
                    : "2px solid #e9ecef"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                {employee?.profile_image ? (
                  <img
                    src={imageUrl}
                    alt="User"
                    loading="lazy"
                    style={{ 
                      objectFit: "cover", 
                      width: "100%", 
                      height: "100%",
                      borderRadius: "50%"
                    }}
                    onLoad={(e) => {
                      if (imageUrl && window.__loadedEmployeeImages) {
                        window.__loadedEmployeeImages.add(imageUrl);
                      }
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.nextSibling.style.display = "flex";
                    }}
                  />
                ) : null}
                <div 
                  style={{
                    width: "100%",
                    height: "100%",
                    display: employee?.profile_image ? "none" : "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#f0f0f0",
                    color: "#adb5bd",
                    borderRadius: "50%",
                    position: employee?.profile_image ? "absolute" : "relative",
                    top: 0,
                    left: 0
                  }}
                >
                  <i className="fa fa-user" style={{ fontSize: "28px" }}></i>
                </div>
              </div>
              {(employee?.is_celeb_birthday || isEventUpcoming(employee?.employment?.employment_date)) && (
                <div style={{
                  position: "absolute",
                  bottom: "-6px",
                  right: "-6px",
                  display: "flex",
                  gap: "6px",
                  zIndex: 2
                }}>
                  {employee?.is_celeb_birthday && (
                    <span 
                      style={{
                        backgroundColor: "#10b981",
                        color: "white",
                        padding: "5px",
                        borderRadius: "50%",
                        fontSize: "13px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "28px",
                        height: "28px",
                        lineHeight: "1",
                        boxShadow: "0 4px 12px rgba(16, 185, 129, 0.5)",
                        border: "3px solid white",
                        animation: "pulse 2s infinite"
                      }}
                      title="Birthday"
                    >
                      <i className="fa fa-birthday-cake"></i>
                    </span>
                  )}
                  {isEventUpcoming(employee?.employment?.employment_date) && (
                    <span 
                      style={{
                        backgroundColor: "#f59e0b",
                        color: "white",
                        padding: "5px",
                        borderRadius: "50%",
                        fontSize: "13px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "28px",
                        height: "28px",
                        lineHeight: "1",
                        boxShadow: "0 4px 12px rgba(245, 158, 11, 0.5)",
                        border: "3px solid white",
                        animation: "pulse 2s infinite"
                      }}
                      title="Work Anniversary"
                    >
                      <i className="fa fa-calendar-check"></i>
                    </span>
                  )}
                </div>
              )}
            </div>
            
            <div className="flex-grow-1 ms-3" style={{ minWidth: 0, zIndex: 1 }}>
              <h4 style={{ 
                fontSize: isMobile ? "15px" : "16px",
                fontWeight: "600",
                color: "#1f2937",
                marginBottom: "2px",
                lineHeight: "1.3"
              }}>
                {employee.first_name} {employee?.middle_name} {employee?.last_name}
              </h4>
              {employee?.employment?.position?.name && (
                <div style={{ 
                  fontSize: "12px",
                  color: "#6b7280",
                  marginBottom: "0px"
                }}>
                  {employee.employment.position.name}
                </div>
              )}
            </div>
          </div>

          {/* Details Section */}
          <div style={{
            borderTop: "1px solid #e5e7eb",
            paddingTop: "12px",
            marginBottom: "12px",
            flex: 1
          }}>
            <div className="row g-2">
              {employee.emp_no && (
                <div className="col-6">
                  <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                    Emp No
                  </div>
                  <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                    {employee.emp_no}
                  </div>
                </div>
              )}
              {employee?.contact?.private_email && (
                <div className="col-6">
                  <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                    Email
                  </div>
                  <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {employee.contact.private_email}
                  </div>
                </div>
              )}
              {employee?.company_phone_number && (
                <div className="col-6">
                  <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                    Phone
                  </div>
                  <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                    {employee.company_phone_number}
                  </div>
                </div>
              )}
              {(() => {
                const storeName = employee?.store?.name || employee?.employment?.store?.name || employee?.store_name;
                return storeName ? (
                  <div className="col-6">
                    <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                      Store
                    </div>
                    <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {storeName}
                    </div>
                  </div>
                ) : null;
              })()}
              
              {/* Report To Section */}
              {employee?.employment?.report_to && (
                <div className="col-12" style={{ marginTop: "8px" }}>
                  <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "6px", fontWeight: "500" }}>
                    Reports To
                  </div>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}>
                    {employee?.employment?.report_to?.profile_image && (
                      <div style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        overflow: "hidden",
                        border: "2px solid #e5e7eb",
                        flexShrink: 0,
                        background: "#ffffff"
                      }}>
                        <img
                          src={employee.employment.report_to.profile_image}
                          alt="Report To"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover"
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                            if (e.target.nextSibling) {
                              e.target.nextSibling.style.display = "flex";
                            }
                          }}
                        />
                        <div style={{
                          width: "100%",
                          height: "100%",
                          display: "none",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#f0f0f0",
                          color: "#adb5bd"
                        }}>
                          <i className="fa fa-user" style={{ fontSize: "12px" }}></i>
                        </div>
                      </div>
                    )}
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEmployeeDetailPage(employee?.employment?.report_to?.id, index);
                      }}
                      style={{ 
                        fontSize: "12px", 
                        color: "rgb(211, 0, 26)",
                        textDecoration: "none",
                        overflow: "hidden", 
                        textOverflow: "ellipsis", 
                        whiteSpace: "nowrap", 
                        flex: 1, 
                        minWidth: 0,
                        cursor: "pointer",
                        border: "none",
                        background: "none",
                        padding: 0,
                        textAlign: "left",
                        fontWeight: "500"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.textDecoration = "underline";
                        e.currentTarget.style.color = "#a0001a";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.textDecoration = "none";
                        e.currentTarget.style.color = "rgb(211, 0, 26)";
                      }}
                    >
                      {employee.employment.report_to.first_name} {employee.employment.report_to.last_name}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          </div>
        </div>
      </div>
    );
  }, (prevProps, nextProps) => {
    // Custom comparison function - return true if props are equal (skip re-render)
    if (prevProps.employee.id !== nextProps.employee.id) {
      return false; // Re-render
    }
    
    const employeeChanged = 
      prevProps.employee.profile_image !== nextProps.employee.profile_image ||
      prevProps.employee.first_name !== nextProps.employee.first_name ||
      prevProps.employee.last_name !== nextProps.employee.last_name ||
      prevProps.employee.status !== nextProps.employee.status ||
      prevProps.employee.is_celeb_birthday !== nextProps.employee.is_celeb_birthday ||
      prevProps.employee.gender !== nextProps.employee.gender;
    
    return !employeeChanged;
  });

  const GridView = () => {
    if (loading && employeeData.length === 0) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {employeeData.map((employee, index) => (
            <EmployeeCard
              key={`employee-${employee.id}`}
              employee={employee}
              index={index}
              handleEmployeeDetailPage={handleEmployeeDetailPage}
              isEventUpcoming={isEventUpcoming}
            />
          ))}
        </>
      );
    }
  };

 



  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Company Directory"
            title="Dashboard"
            subtitle="Company Directory"
            modal="#add_employee"
            name="Add Employee"
            // Linkname="/employees"
            // Linkname1="/employees-list"
            view={view}
            setView={setView}
          />
          <EmployeeListFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search employee"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
            appliedFilterCount={appliedFilterCount}
            handleExport={handleExport}
            exportLoading={exportLoading}
             />

          {view === "grid" ? (
            <div className="row">
              {/* <div className="my-2" >
            <SearchBox handleChange={handleGridChange} pageSettings={pageSettings} setPageSettings={setPageSettings} />
            
            </div> */}
              <GridView />

              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination

                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}

                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                          
                        );
                      }
                      return null;
                    }}

                    />
                  {/* <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    itemRender={itemRender}
                    onChange={handleGridChange}
                  /> */}
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <div className="table-responsive" style={{ overflowX: "auto" }}>
                    <style>{`
                      @keyframes pulse {
                        0%, 100% {
                          transform: scale(1);
                          opacity: 1;
                        }
                        50% {
                          transform: scale(1.1);
                          opacity: 0.9;
                        }
                      }
                      .modern-table .ant-table-tbody > tr {
                        background-color: #ffffff !important;
                      }
                      .modern-table .ant-table-tbody > tr:hover > td {
                        background-color: #f5f5f5 !important;
                      }
                      .modern-table .ant-table-thead > tr > th {
                        background-color: #f8f9fa !important;
                        font-weight: 600;
                        color: #333;
                        border-bottom: 2px solid #e0e0e0;
                        padding: 10px 12px;
                        font-size: 13px;
                      }
                      .modern-table .ant-table-tbody > tr > td {
                        border-bottom: 1px solid #f0f0f0;
                        padding: 10px 12px;
                        font-size: 13px;
                      }
                      .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                        padding: 16px;
                        border-top: 1px solid #f0f0f0;
                        background-color: #ffffff;
                        border-bottom-left-radius: 12px;
                        border-bottom-right-radius: 12px;
                      }
                    `}</style>
                    <Table
                      className="mb-0 modern-table"
                      style={{ 
                        borderRadius: "12px",
                        minWidth: "100%"
                      }}
                      scroll={{ x: "max-content" }}
                      columns={columns}
                      dataSource={employeeData}
                      rowKey={(record) => record.id}
                      loading={loading}
                      pagination={{
                        total: pageSettings?.total,
                        pageSize: pageSettings?.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: pageSizeOptions,
                        itemRender: itemRender,
                        position: "right",
                        current: pageSettings?.page,
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${total} items`,
                        style: { padding: "16px" }
                      }}
                      components={{
                        body: {
                          row: CustomRow,
                        },
                      }}
                      onRow={(record, index) => ({
                        record,
                        index,
                        style: {
                          cursor: 'pointer',
                          transition: 'background-color 0.2s',
                          backgroundColor: '#ffffff'
                        },
                        onMouseEnter: (e) => {
                          e.currentTarget.style.backgroundColor = '#f8f9fa';
                        },
                        onMouseLeave: (e) => {
                          e.currentTarget.style.backgroundColor = '#ffffff';
                        }
                      })}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <AllEmployeeAddPopup />
      {/* Delete Modal */}
      <DeleteModal Name="Delete Employee" />

      <FilterDrawer


        searchPlaceholder={"Search employee"}
        showFilterDrawer={showFilterDrawer}
        handleFilterDrawer={handleFilterDrawer}

        handleFilterChange={handleFilterChange}
        filters={filters}
        handleInputChange={handleInputChange}
        handleApplyFilter={handleApplyFilter}
        filterLoading={filterLoading}
        handleDateChange={handleDateChange}
        handleClearAll={handleClearAll}
        isFilterDirty={isFilterDirty}
      />
      {/* Delete Modal */}
    </div>
  );
};

export default AllEmployee;
